module.exports = __webpack_public_path__ + "static/img/10011 (3).142c6af.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10011 (3).webp
// module id = dOrE
// module chunks = 14